SupportbasePopupView = require('../base_popup_view')
SupportV1OrderListView = require('./v1_order_list_view')
SupportSelectDifferentOrderMenuTemplate = require('../../../select_different_order_menu.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SupportV1SelectDifferentOrderMenuView extends Backbone.View
  className: 'row'

  initialize: ->
    @template = SupportSelectDifferentOrderMenuTemplate
    orderListView = new SupportV1OrderListView({
      currentOrdersFilter: Groupon.Support.currentOrdersFilter
    })
    @baseView = new SupportbasePopupView({
      popupView : orderListView
    })

  render: ->
    @$el.append toHtml(@template, {faqInsteadHelpWizard: window.faqInsteadHelpWizard}, @I18nScope)

  actionHandler: ()->
    @baseView.render()

  events :
    "click #chooseOrder"  : "actionHandler"

module.exports = SupportV1SelectDifferentOrderMenuView
